import React, { Component, ChangeEvent } from "react";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { _ } from "libs";

type OnSearchChange = (value: string) => void;
type Props = {
	onChange: OnSearchChange;
	debounce?: number;
} & Partial<DefaultProps>;
type DefaultProps = Readonly<typeof defaultProps>;
const defaultProps = {
	debounce: 300
};

export default class SearchInput extends Component<Props> {
	state = {
		value: ""
	};

	subscription = null;
	onType$ = null;

	static defaultProps = defaultProps;

	constructor(props) {
		super(props);

		this.onType$ = new Subject();
	}

	componentDidMount() {
		this.subscription = this.onType$
			.pipe(debounceTime(this.props.debounce), distinctUntilChanged())
			.subscribe((value: string) => {
				this.props.onChange(value);
			});
	}

	componentWillUnmount() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;

		this.setState({ value }, () => {
			this.onType$.next(value);
		});
	};

	render() {
		return (
			<div className="field searchField searchFieldWithIcon">
				<div className="input">
					<input type="text" onChange={this.handleChange} value={this.state.value} placeholder={_("form.searchPlayer.placeholder")} />
				</div>
			</div>
		);
	}
}
